// src/App.js
import React from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './context/AuthContext'
import "./styles/theme.css";

import SessionTimeout from './components/SessionTimeout'
import NavigationBar from './components/NavigationBar'
import ProtectedRoute from './components/ProtectedRoute'
import PageWrapper from './components/PageWrapper'

import LoginPage from './components/LoginPage'
import ForgotPasswordPage from './components/ForgotPasswordPage'
import ResetPasswordPage from './components/ResetPasswordPage'
import Dashboard from './components/Dashboard'
import KpiDashboard from './components/KpiDashboard'
import ImageGrid from './components/ImageGrid'
import RecordsTable from './components/RecordsTable'
import Reports from './components/Reports'
import AdvancedSearch from './components/AdvancedSearch'
import DeviceTable from './components/DeviceTable'
import ProfilePage from './components/ProfilePage'
import NotificationPage from './components/NotificationPage'
import PendingActivationTable from './components/PendingActivationTable'
import AdminDashboard from './components/supportDashboard/AdminDashboard'
import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { useSidebar } from './context/SidebarContext'
import Users from './components/UsersTable'
import TransfersUsersTable from './components/transfers/TransfersUsersTable'
import SupportDashboard from './components/supportDashboard/SupportDashboardPage';
import AnalystTable from './components/AnalystTable';
import { UserType } from './constants/userType';

export default function App() {
  const { token } = useAuth()
  const location = useLocation()
  const isAuthPage = ['/login', '/forgot-password', '/reset-password'].includes(location.pathname)
  const { isExpanded } = useSidebar();

  return (
    <>
      <SessionTimeout />
      {token && <NavigationBar />}
      <div className={isAuthPage ? '' : `main-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
        <div className="app">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute allow={['teamleader', 'super']}>
                  <PageWrapper>
                    <Dashboard />
                  </PageWrapper>
                </ProtectedRoute>
              }
            />

            <Route
              path="/dashboard-kpi"
              element={
                <ProtectedRoute allow={['teamleader', 'super']}>
                  <PageWrapper>
                    <KpiDashboard />
                  </PageWrapper>
                </ProtectedRoute>
              }
            />

            <Route
              path="/images"
              element={
                <ProtectedRoute>
                  <PageWrapper>
                    <ImageGrid />
                  </PageWrapper>
                </ProtectedRoute>
              }
            />

            <Route
              path="/incidents"
              element={
                <ProtectedRoute>
                  <PageWrapper>
                    <RecordsTable />
                  </PageWrapper>
                </ProtectedRoute>
              }
            />

            <Route
              path="/Analysts"
              element={
                <ProtectedRoute>
                  <PageWrapper>
                    <AnalystTable />
                  </PageWrapper>
                </ProtectedRoute>
              }
            /> 

              <Route
              path="/users"
              element={
                <ProtectedRoute>
                  <PageWrapper>
                    <Users />
                  </PageWrapper>
                </ProtectedRoute>
              }
            />

            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <PageWrapper>
                    <Reports />
                  </PageWrapper>
                </ProtectedRoute>
              }
            />

            <Route
              path="/devices"
              element={
                <ProtectedRoute>
                  <PageWrapper>
                    <>
                      <AdvancedSearch />
                      <DeviceTable />
                    </>
                  </PageWrapper>
                </ProtectedRoute>
              }
            />

            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <PageWrapper>
                    <ProfilePage />
                  </PageWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/notifications"
              element={
                <ProtectedRoute>
                  <PageWrapper>
                    <NotificationPage />                    
                  </PageWrapper>
                </ProtectedRoute>
              }
            />
            <Route
              path="/pending-activation"
              element={
                <ProtectedRoute>
                  <PageWrapper>
                    <PendingActivationTable />
                  </PageWrapper>
                </ProtectedRoute>
              }
            />

            <Route
              path="/transfers-users"
              element={
                <ProtectedRoute>
                  <PageWrapper>
                    <TransfersUsersTable />
                  </PageWrapper>
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin-Dashboard"
              element={
                <ProtectedRoute allow={['support', 'admin', 'super']}>
                  <PageWrapper>
                    <AdminDashboard />
                  </PageWrapper>
                </ProtectedRoute>
              }
            />
            
            <Route
              path="/support-dashboard/*"
              element={
                <ProtectedRoute allow={['support', 'super']}>
                  <PageWrapper>
                    <SupportDashboard />
                  </PageWrapper>
                </ProtectedRoute>
              }
            />

            <Route
              path="/device-telemetry"
              element={
                <ProtectedRoute allow={[UserType.SUPPORT, UserType.SUPER]}>
                  <Navigate to="/support-dashboard/device-telemetry" replace />
                </ProtectedRoute>
              }
            />

            <Route
              path="*"
              element={
                <ProtectedRoute>
                  <Navigate to="/login" replace />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </div>
    </>
  )
}
